module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-dropdown', [_c('vbl-button', [_vm._v("请选择")]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                自定义内容自定义内容自定义内容自定义内容自定义内容\n            ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a419d36a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblDropdown/example/vblDropdownExample.vue
// module id = 288
// module chunks = 0